import { ReportItemsCountsAppModel, StandingAccessReportAppModel } from '@api';
import { ReportTierOptions, TIER_SCORE_MAP } from '@StandingAccess/types';

export const calculateTierScore = (irasCount: number, irasScore: number, maxScore: number) => {
  if (irasCount === 0) return maxScore;

  // Calculate percentage: (actual score / maximum possible score) * maxScore
  // Maximum possible score per IRA is 1, so maximum total = irasCount * 1
  const percentage = (irasScore / irasCount) * maxScore;

  // Round to 2 decimal places to avoid floating point issues
  return Math.round(percentage * 100) / 100;
};

const emptyTierSummary: ReportItemsCountsAppModel = {
  entitlements: 0,
  identities: 0,
  iras: 0,
  iras_revoked: 0,
  iras_in_access_flow: 0,
  iras_posture: 0,
};

export const getTierSummary = (
  report: StandingAccessReportAppModel,
  tier: ReportTierOptions,
): ReportItemsCountsAppModel => report.items_counts_summary.tiers_summary[tier] || emptyTierSummary;

export default function useReportScore({ report }: { report: StandingAccessReportAppModel }) {
  const tiers = [ReportTierOptions.critical, ReportTierOptions.high, ReportTierOptions.medium, ReportTierOptions.low];
  const score = tiers.reduce(
    (acc, tier) =>
      acc +
      calculateTierScore(
        getTierSummary(report, tier).iras,
        getTierSummary(report, tier).iras_posture,
        TIER_SCORE_MAP[tier],
      ),
    0,
  );

  return {
    score,
  };
}
